/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/core/IsPublicIP.ts
 * @create:      2025-07-01 17:10:49.336
 * @modify:      2025-07-11 21:19:12.936
 * @version:     6.0.0
 * @times:       5
 * @lines:       54
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { IsLoopbackIP } from "./IsLoopbackIP";
import { IsPrivateIP } from "./IsPrivateIP";

/**
 * Determines whether the given IP address is a public IP address.
 *
 * An IP address is considered public if it is neither a private IP address nor a loopback address.
 *
 * @param ip - The IP address to check.
 * @returns `true` if the IP address is public; otherwise, `false`.
 * 
 * @since 4.2.4
 * @version 2023-09-02
 */
export function IsPublicIP(ip: string) {
    if (IsPrivateIP(ip) || IsLoopbackIP(ip)) {
        return false;
    }

    return true;
}
